'use strict';
import * as $j_com$002eraquo$002eairstream$002ecommon$002e$002dInternal$002dTry$002dObserver from "./com.raquo.airstream.common.-Internal-Try-Observer.js";
import * as $j_com$002eraquo$002eairstream$002ecommon$002e$002dSingle$002dParent$002dSignal from "./com.raquo.airstream.common.-Single-Parent-Signal.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable from "./com.raquo.airstream.core.-Base-Observable.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed from "./com.raquo.airstream.core.-Named.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dSignal from "./com.raquo.airstream.core.-Writable-Signal.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_airstream_distinct_DistinctSignal(parent, isSame, resetOnStop) {
  this.DN = null;
  this.DM = false;
  this.DO = null;
  this.yo = 0;
  this.DK = null;
  this.DL = null;
  this.DS = false;
  this.yq = null;
  this.DP = false;
  this.DJ = 0;
  this.yr = null;
  this.yp = null;
  this.DQ = false;
  this.DR = 0;
  this.yr = parent;
  this.yp = isSame;
  this.DQ = resetOnStop;
  this.DN = (void 0);
  $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable.$f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  this.yo = 0;
  $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable.$f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.yq = (void 0);
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dSingle$002dParent$002dSignal.$f_Lcom_raquo_airstream_common_SingleParentSignal__$init$__V(this);
  this.DR = ((1 + parent.dT()) | 0);
}
export { $c_Lcom_raquo_airstream_distinct_DistinctSignal as $c_Lcom_raquo_airstream_distinct_DistinctSignal };
$p = $c_Lcom_raquo_airstream_distinct_DistinctSignal.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_airstream_distinct_DistinctSignal;
/** @constructor */
function $h_Lcom_raquo_airstream_distinct_DistinctSignal() {
}
export { $h_Lcom_raquo_airstream_distinct_DistinctSignal as $h_Lcom_raquo_airstream_distinct_DistinctSignal };
$h_Lcom_raquo_airstream_distinct_DistinctSignal.prototype = $p;
$p.dP = (function() {
  return this.DN;
});
$p.dd = (function() {
  return $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed.$f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$p.b = (function() {
  return $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed.$f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.gA = (function() {
  return this.DM;
});
$p.fm = (function() {
  return this.DO;
});
$p.ea = (function(x$1) {
  this.DM = x$1;
});
$p.gD = (function(x$1) {
  this.DO = x$1;
});
$p.f = (function(obj) {
  return (this === obj);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$systemIdentityHashCode(this);
});
$p.gs = (function() {
  return this.yo;
});
$p.kI = (function(x$1) {
  this.yo = x$1;
});
$p.hm = (function(observer) {
  observer.fY($j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dSignal.$f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this));
});
$p.ew = (function() {
  return this.DK;
});
$p.ey = (function() {
  return this.DL;
});
$p.hw = (function() {
  return this.DS;
});
$p.g1 = (function(x$1) {
  this.DS = x$1;
});
$p.hf = (function(x$0) {
  this.DK = x$0;
});
$p.hg = (function(x$0) {
  this.DL = x$0;
});
$p.l3 = (function() {
  return this.yq;
});
$p.rb = (function(x$1) {
  this.yq = x$1;
});
$p.b3 = (function() {
  return $j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dSignal.$f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this);
});
$p.fW = (function(nextValue, transaction) {
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dInternal$002dTry$002dObserver.$f_Lcom_raquo_airstream_common_InternalTryObserver__onNext__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.fV = (function(nextError, transaction) {
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dInternal$002dTry$002dObserver.$f_Lcom_raquo_airstream_common_InternalTryObserver__onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$p.rc = (function() {
  return this.DP;
});
$p.tQ = (function() {
  return this.DJ;
});
$p.kJ = (function(x$1) {
  this.DJ = x$1;
});
$p.u2 = (function(x$0) {
  this.DP = x$0;
});
$p.hp = (function() {
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dSingle$002dParent$002dSignal.$f_Lcom_raquo_airstream_common_SingleParentSignal__onWillStart__V(this);
});
$p.hn = (function() {
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dSingle$002dParent$002dSignal.$f_Lcom_raquo_airstream_common_SingleParentSignal__onStart__V(this);
});
$p.ho = (function() {
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dSingle$002dParent$002dSignal.$f_Lcom_raquo_airstream_common_SingleParentSignal__onStop__V(this);
});
$p.dT = (function() {
  return this.DR;
});
$p.fX = (function(nextParentValue, transaction) {
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dSingle$002dParent$002dSignal.$f_Lcom_raquo_airstream_common_SingleParentSignal__onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextParentValue, transaction);
  if ((!(!(!this.yp.bB($j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dSignal.$f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this), nextParentValue))))) {
    $j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dSignal.$f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextParentValue, transaction);
  }
});
$p.id = (function() {
  return this.yr.b3();
});
$p.ll = (function(nextValue, nextParentLastUpdateId) {
  if ((this.DQ || (!(!(!this.yp.bB(nextValue, $j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dSignal.$f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this))))))) {
    $j_com$002eraquo$002eairstream$002ecommon$002e$002dSingle$002dParent$002dSignal.$f_Lcom_raquo_airstream_common_SingleParentSignal__updateCurrentValueFromParent__s_util_Try__I__V(this, nextValue, nextParentLastUpdateId);
  }
});
$p.eB = (function() {
  return this.yr;
});
$p.hi = (function(isSame) {
  return new $c_Lcom_raquo_airstream_distinct_DistinctSignal(this, isSame, false);
});
$p.dS = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_distinct_DistinctSignal = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_airstream_distinct_DistinctSignal, "com.raquo.airstream.distinct.DistinctSignal", ({
  gU: 1,
  a1: 1,
  M: 1,
  ai: 1,
  ak: 1,
  au: 1,
  az: 1,
  as: 1,
  aQ: 1,
  aj: 1,
  ay: 1,
  b1: 1
}));
export { $d_Lcom_raquo_airstream_distinct_DistinctSignal as $d_Lcom_raquo_airstream_distinct_DistinctSignal };
